//@vendors
const Immutable = require("immutable");
const { handleActions } = require("redux-actions");
//@actions
const { simpleActions } = require("../actions/aresDossier");

const setInitialState = () =>
    Immutable.fromJS({
        success: false,
        isFetching: true,
        error: false,
        dossier: null,
        cardDeniedVisible: false,
    });

const aresDossierReducer = handleActions(
    {
        [simpleActions.aresDossierStatus]: (state) =>
            state.merge({
                isFetching: true,
                success: false,
                error: false,
            }),
        [simpleActions.aresDossierStatusSuccess]: (state, action) =>
            state.merge({
                dossier: action.payload.response,
                isFetching: false,
                success: true,
                error: false,
            }),
        [simpleActions.aresDossierStatusError]: (state, action) =>
            state.merge({
                isFetching: false,
                success: false,
                error: action.payload.error,
            }),
        [simpleActions.aresDossierLoanComplete]: (state, action) =>
            state.merge({
                dossier: action.payload.response,
                isFetching: false,
                success: true,
                error: false,
            }),
    },
    setInitialState()
);

module.exports = aresDossierReducer;
module.exports.setInitialState = setInitialState;
